<template>
  <v-btn
    :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
    color="primary"
    data-cy="btn_enviar"
    :disabled="desabilitarBtn"
    :loading="botaoLoading"
    @click="salvarDados()"
  >
    Salvar
  </v-btn>
</template>

<script>
import ApiMeuPerfil from '@/api/meuPerfil';
import ApiScoreConsumidor from '@/api/scoreConsumidor';

export default {
  name: 'BtnSalvar',

  props: {
    desabilitarBtn: {
      type: Boolean,
      required: true,
    },
    dadosCartao: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      botaoLoading: false,
    };
  },

  methods: {
    async scoreConsumidor() {
      await ApiScoreConsumidor.scoreConsumidor('profile_credit_card');
    },

    salvarDados() {
      const formData = new FormData();
      this.botaoLoading = true;

      formData.append('number', this.dadosCartao.number);
      formData.append('name', this.dadosCartao.name);
      formData.append('expiration_date', this.dadosCartao.expiration_date);
      formData.append('security_token', this.dadosCartao.security_token);
      formData.append('nickname', this.dadosCartao.nickname);
      formData.append('brand', this.dadosCartao.flagOperator);

      ApiMeuPerfil.creditCardSave(formData)
        .then(() => {
          this.$emit('respostaApi', true);
          this.scoreConsumidor();
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : 'Tente novamente mais tarde.';
          this.$emit('respostaApi', false, errorMessage);
        })
        .finally(() => {
          this.botaoLoading = false;
        });
    },
  },
};
</script>
